import './StatCard.css';

const StatCard = ({ title, value, icon: Icon, color, trend, trendValue }) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className="stat-icon" style={{ background: color }}>
          <Icon />
        </div>
        <span className="stat-title">{title}</span>
      </div>
      <div className="stat-value">{value}</div>
      {trend && (
        <div className={`stat-trend ${trend}`}>
          <span className="trend-arrow">{trend === 'up' ? '↑' : '↓'}</span>
          <span className="trend-value">{trendValue}</span>
          <span className="trend-label">vs last month</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
